import { initializeApp } from 'firebase/app';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyCKYc63bMYkFcq5BjzzOnUbsvasRMy5Ar8',
  authDomain: 'smartshoppinglist-6052b.firebaseapp.com',
  databaseURL: 'https://smartshoppinglist-6052b.firebaseio.com',
  projectId: 'smartshoppinglist-6052b',
  storageBucket: 'smartshoppinglist-6052b.appspot.com',
  messagingSenderId: '229669471138'
};

const firebaseApp = initializeApp(config);

firebaseApp.firestore().settings({ timestampsInSnapshots: true });

export function checkAuth(context) {
  return new Promise(function(resolve, reject) {
    firebaseApp.auth().onAuthStateChanged(function(user) {
      if (user) {
        let hasGoogleProvider = true;

        user.providerData.forEach(function(provider) {
          if (provider.providerId === 'google.com') {
            hasGoogleProvider = true;
          }
        });

        if (hasGoogleProvider) {
          context.$store.state.user.displayName = user.displayName;
          context.$store.state.user.photoURL = user.photoURL;
        } else {
          context.$store.state.user.displayName = user.email;
          context.$store.state.user.photoURL = '/static/img/header.jpg';
        }

        context.$store.state.user.uid = user.uid;
        context.$store.state.user.email = user.email;

        resolve();
      } else {
        reject();
      }
    });
  });
}

export const firestore = firebaseApp.firestore();
export default firebaseApp;
